import { ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { SITE_URL } from "@/lib/journalApi";
import Header from "./Header";
import Footer from "./Footer";
import FloatingWhatsApp from "@/components/shared/FloatingWhatsApp";

interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  const { pathname } = useLocation();
  const canonical = SITE_URL + (pathname === "/" ? "/" : pathname.replace(/\/$/, ""));
  return (
    <div className="flex flex-col min-h-screen bg-cream">
      <Helmet><link rel="canonical" href={canonical} /></Helmet>
      <Header />
      <main className="flex-1">
        {children}
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
};

export default Layout;
